class TabbedCollectionsComponent extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.tabbed-collections__tab');
    this.panels = this.querySelectorAll('.tabbed-collections__panel');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
  }

  switchTab(selectedTab) {
    const index = selectedTab.dataset.tabIndex;

    this.tabs.forEach((tab) => {
      tab.classList.remove('tabbed-collections__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = true;
    });

    selectedTab.classList.add('tabbed-collections__tab--active');
    selectedTab.setAttribute('aria-selected', 'true');

    const targetPanel = this.panels[index];
    if (targetPanel) {
      targetPanel.hidden = false;
    }
  }
}

if (!customElements.get('tabbed-collections-component')) {
  customElements.define('tabbed-collections-component', TabbedCollectionsComponent);
}
